import type { IconType } from 'react-icons';

import { cn } from '../lib/utils';
import { iconColorClass, type ArticIconProps } from './shell';

export type ReactIconComponentProps = ArticIconProps;

export function createReactIcon(ReactIconComponent: IconType, displayName: string) {
  function Component({ color = 'current', className, ...props }: ReactIconComponentProps) {
    return (
      <ReactIconComponent
        className={cn(iconColorClass[color], className)}
        data-slot="icon"
        {...props}
      />
    );
  }
  Component.displayName = displayName;
  return Component;
}
